var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"requirement-form-layout",attrs:{"id":"create-requirement"}},[_c('edit-requirement-form',{attrs:{"requirementFormInfo":_vm.requirementInfo,"submit":_vm.createRequirement}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }